import { action, observable, computed, reaction, makeObservable } from 'mobx';
import { Disposers, GuessServerTime, HttpPromiseState, logger } from 'lib/helpers';
import { Homework } from 'scenes/homework/homework-models';
import { HomeworkLoaders } from 'scenes/homework/stores/homework-loaders';
import { PagedListResponse } from '../../domain';
import {StudentHomeworkListDto, HomeworkStatus, HomeworkStatuses } from './models/homeworkList-models';
import {Control, StringControl, validators} from '../../lib/helpers';

export class StudentHomeworkListStore {
  @observable
  currentPage: number = 0;
  status: Control<HomeworkStatus[]>;
  filterDate: string | null

  @observable.ref
  homeworkState: HttpPromiseState<PagedListResponse<Homework>> | null;

  private readonly disposers = new Disposers();

  constructor() {
    makeObservable(this);
    this.currentPage = 0;
    this.homeworkState =null;    
    this.status = new Control<HomeworkStatus[]>('', []);
    this.setup();
    this.filterDate = null;
  }

  @action
  resetResults = () => {
    window.location.reload();
  };

  @action
  load = () => {
    if (this.homeworkState?.isPending)
      return;
    logger.log('StudentHomeworkListStore.loading');
    
    const request: StudentHomeworkListDto = {
      Filter: this.state,
      Page: this.currentPage,
      FilterDate: this.filterDate
    };

    this.homeworkState = HomeworkLoaders.Student.getPendingHomeworks(request);
  };
  
  @action
  loadNextPage = () => {
    
    this.currentPage++;
    this.load();
  };

  @action
  loadPreviousPage = () => {
    
    this.currentPage--;
    this.load();
  };

  @action
  getDay = () => {
    this.filterDate = "Day"
    this.load();
  };

  @action
  getMonth = () => {
    this.filterDate = "Month"
    this.load();
  };
  @action
  getWeek = () => {
    this.filterDate = "Week"
    this.load();
  };

  @action
  getYear = () => {
    this.filterDate = "Year"
    this.load();
  };

  @computed
  get state(): string[] {
    return this.status.value
  }

  private setup() {
    this.load();
  }

  dispose = () => {
    this.disposers.dispose();
  };
}
